<template lang='pug'>
    renderer(ref='renderer',
            @start='startLoading',
            :size='size'
            :unit='{x:4,y:4}',
            :background-color='backgroundColor',
            :layers='transformsAndSource.from.layers'
            :enable-panning='enablePanning'
            @clickOnCanvas='deselectAll',
            @selections-start='onSelectionsStart',
            @selections-end='onSelectionsEnd',
            @panmove='onPanMove',
            @panstart='onPanStart',
            @panend='onPanEnd',
            @mousewheel='onMouseWheel',
            @pinchstart='onPinchStart',
            @pinchmove='onPinchMove',
            @pinchend='onPinchEnd',
            @stop='doneLoading')

      //template(#top='{renderTools}')
        p.text-white lal {{draggingKeepRatio}}

      //template(v-if='showRenderStats',#top='{renderTools}')
        div(style='position:absolute; top:0px; left:0px; z-index:99; background-color:#cecece',@click='showRenderStats = false')
          renderer-stats(:render-tools='renderTools')

      //template(v-else,#top)
        div(style='position:absolute; top:0px; right:0px; z-index:99')
          button.button.is-small(@click='showRenderStats = true') Stats

      template(#loading)
        loading(:is-full-page='false',
                  :active='true')

      template(#view='{renderTools,container,pixiApp,canvas,screenContainer}')
        rectangle(:parent-container='container'
                  :bounds='canvasBounds'
                  :render-tools='renderTools'
                  :fill='false'
                  :line-color='0xffffff'
                  :alpha='0.5'
                  :line-width='3')
        slot(name='always',v-bind:nothing-selected='nothingSelected')
        portal-target(name='canvasOverlay',multiple)
        .absolute.bottom-0.left-0.flex.right-0(
          class='sm:right-auto'
          )
          portal-target.w-full.pbc-z-level-1(name='selectionSlots',multiple,class="sm:w-auto")
        //cache-as-bitmap(v-if='!loading', :container='container',:render-tools='renderTools')
        selection(v-if='canvas',
          :selections='selections',
          :element='canvas',
          @start-selection='selecting = true',
          @stop-selection='selecting = false'
          )
        moveable.moveable-targets(ref='moveable',
          :keep-ratio='draggingKeepRatio'
          @drag-start='onDragStartUndo',
          @drag-end='onDragEndUndo'
          @rotate-start='onRotateStartUndo',
          @rotate-end='onRotateEndUndo',
          @scale-start='onScaleStartUndo',
          @scale-end='onScaleEndUndo',
          @tap='onTap'
        )
          div(v-if='!dragging',ref='moveableTargets',v-for='moveableTarget in moveableTargets',:key='moveableTarget.key')
            resize(:bounds='moveableTarget.bounds',
              :renderer='$refs.renderer',
              :render-tools='renderTools',
              :moveable='$refs.moveable',
              :indirectlySelected='moveableTarget.indirectlySelected',
              :update-container-bounds='moveableTarget.updateContainerBounds',
              :parent-holder='moveableTarget.holder',
              :key='moveableTarget.key',
              :mykey='moveableTarget.key',
              :transform='moveableTarget.transform',
              :num-selections='moveableTargets.length'
              @drag-start='busyDragging = true; moveableTarget.holder.events().emit("drag-start")',
              @drag-end='busyDragging = false; moveableTarget.holder.events().emit("drag-start")'
              )

        .selectable-targets(v-if='showTransforms')
          div(v-for='transform in transformsAndSource.transforms',
              :key='transform.id')
            edit-transform(:transform='transform',
              @select='onSelect',
              @select-add='onSelectAdd',
              @deselect='onDeselect',
              @drag-start='onDragStartUndo',
              @drag-end='onDragEndUndo'
              :selections='selections',
              :indirect-selections='indirectSelections',
              :parent-container='container',
              :render-tools='renderTools',
              :partutil='partutil',
              :loading='loading',
              :context='transformContext',
              :enable-interaction='isAdvancedMode || editing',
              :unselectable-transforms='unselectableTransforms'
              :key='transform.id')
              template(#default='{holder,transform,updateContainerBounds}')
                .add-moveable-target
                add-holder-data(:holders='holderData',
                  :transform='transform',
                  :holder='holder',
                  :update-container-bounds='updateContainerBounds')
                  
              template(#selected="{holder,transform,bounds,updateContainerBounds,indirectlySelected,handlers,parentTransform,indirectTransform,childComponent,...rest}")
                portal(to='selectionSlots')
                  //div.absolute.right-0.bottom.-my-12(v-if='!indirectlySelected')
                    pbc-button(@click='zoomOut')
                      magnify-minus.float-left(:size='32')
                    pbc-button(@click='zoomIn')
                      magnify-plus.float-left(:size='32')
                  slot(name='selected',
                    v-bind:transform='transform',
                    v-bind:indirectTransform='indirectTransform',
                    v-bind:indirectlySelected='indirectlySelected',
                    v-bind:updateContainerBounds='updateContainerBounds',
                    v-bind:parentTransform='parentTransform',
                    v-bind:childComponent='childComponent',
                    v-bind:moveable='$refs.moveable',
                    v-bind:holder='holder',
                    v-bind:bounds='bounds'
                    v-bind='rest'
                    )
                add-moveable-target.add-moveable-target(:bounds='bounds',
                  :add-target='addTarget',
                  :update-target='updateTarget',
                  :remove-target='removeTarget',
                  :update-container-bounds='updateContainerBounds',
                  :holder='holder',
                  :moveable='$refs.moveable',
                  :indirectly-selected='indirectlySelected',
                  :parent-transform='parentTransform',
                  :key='indirectTransform.id',
                  :transform='indirectTransform')
        div(v-if='nothingSelected')
          //div.absolute.bottom-0.right-0.p-2
            pbc-button(@click='zoomOut')
              magnify-minus.float-left(:size='32')
            pbc-button(@click='zoomIn')
              magnify-plus.float-left(:size='32')
          slot(name='nothing-selected',
            :transforms-and-source='transformsAndSource')
</template>
<script>
import { mapState } from 'vuex';
import Selection from '@edit/atoms/Selection.vue';
import AddMoveableTarget from '@edit/atoms/AddMoveableTarget.vue';
import AddHolderData from '@edit/atoms/AddHolderData.vue';
import Moveable from '@edit/atoms/Moveable.vue';
import EditTransform from './EditTransform.vue';
import RendererStats from '@edit/atoms/RendererStats.vue';
import CacheAsBitmap from '@edit/atoms/CacheAsBitmap.vue';
import Resize from '@edit/molecules/Resize.vue';
import Renderer from '@edit/atoms/Renderer.vue';
import Partutil from '@edit/tree/partutil.js';
import MagnifyMinus from '@icons/MagnifyMinus.vue';
import MagnifyPlus from '@icons/MagnifyPlus.vue';
import Rectangle from '@edit/atoms/Rectangle.vue';

export default {
  props:{
    transformsAndSource:{
      type:Object,
      required:true
    },
    scale:{
      type:Object,
      default() {
        return {
          x:2,
          y:2
        }
      }
    },
    size: {
      type: Object,
      default() {
        return {
          cols:9,
          rows:16
        }
      }
    },
    backgroundColor:{
      type:String,
      default:'#000000'
    },
    showRenderStats:{
      type:Boolean,
      default:false
    },
    selections:{
      type:Object,
      default() {
        return {
        }
      }
    },
    indirectSelections:{
      type:Object,
      default() {
        return {
        }
      }
    },
    holderData:{
      type:Object,
      default() {
        return {
        }
      }
    },
    editing:{
      type:Boolean,
      default:false
    },
    selectedLayers:{
      type:Object,
      required:true
    },
    enablePanning:{
      type:Boolean,
      default:true
    },
    unselectableTransforms: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components:{
    CacheAsBitmap,
    Selection,
    AddMoveableTarget,
    Moveable,
    Resize,
    RendererStats,
    EditTransform,
    Renderer,
    AddHolderData,
    MagnifyPlus,
    MagnifyMinus,
    Rectangle
  },
  beforeCreate() {
  },
  data() {
    const partutil = new Partutil(this.transformsAndSource);
    return {
      loading:true,
      hasSelection:'',
      partutil,
      lol:true,
      shiftPressed:false,
      selecting:false,
      busyDragging:false,
      moveableTargets:[],
      showTransforms:true,
      dragging:false,
      multipleSelections:[],
      isFirstLoad:true
    }
  },
  methods:{
    onAutoScale() {
      this.onSaveDraft();
    },
    onPinchStart(e) {
      this.dragging = true;
      this.pinching = true;
      delete this.pinchStartScale;
    },
    onPinchMove(e) {
      if (!this.pinching) {
        return;
      }
      const container = this.$refs.renderer.container;
      if (!this.pinchStartScale) {
        this.pinchStartScale = container.scale.x;
      }
      const scale = e.scale;
      container.scale.x = this.pinchStartScale * scale;
      container.scale.y = this.pinchStartScale * scale;
      this.$refs.renderer.renderUpdate();
    },
    onPinchEnd(e) {
      this.dragging = false;
      this.pinching = false;
      delete this.pinchStartScale;
      this.updateAllContainerBounds();
    },
    zoomIn() {
      const stage = this.$refs.renderer.pixiApp.stage;
      const container = this.$refs.renderer.container;
      const scale = 1/10 * stage.scale.x;
      stage.scale.x += scale;
      stage.scale.y += scale;

      this.zoom();
    },
    zoomOut() {
      const stage = this.$refs.renderer.pixiApp.stage;
      const container = this.$refs.renderer.container;
      const scale = 1/10 * stage.scale.x;
      //container.scale.x -= scale;
      //container.scale.y -= scale;
      stage.scale.x -= scale;
      stage.scale.y -= scale;

      this.zoom();
    },
    zoom() {
      this.dragging = true;
      const renderer = this.$refs.renderer.pixiApp.renderer;
      const container = this.$refs.renderer.container;
      this.$refs.renderer.renderUpdate();
      if (this._resetAfterMouseWheelTimeout) {
        clearTimeout(this._resetAfterMouseWheelTimeout);
      } else {
        this.$emit("zoomstart");
      }
      this._resetAfterMouseWheelTimeout = setTimeout( () => {
        this.$emit("zoomend");
        this.dragging = false;
        this.updateAllContainerBounds();
        delete this._resetAfterMouseWheelTimeout;
      }, 400);
    },
    onMouseWheel(e) {
      if (e.deltaY < 0) {
        this.zoomIn();
      } else {
        this.zoomOut();
      }
    },
    onPanStart() {
      const stage = this.$refs.renderer.pixiApp.stage;
      this.startPan = [
        stage.pivot.x,
        stage.pivot.y
      ]
      this.dragging = true;
      this.$emit("panstart");
    },
    onPanMove(e) {
      const stage = this.$refs.renderer.pixiApp.stage;
      const renderer = this.$refs.renderer.pixiApp.renderer;
      const {deltaX,deltaY} = e;
      const pivot = {
        x:this.startPan[0] - deltaX/stage.scale.x,
        y:this.startPan[1] - deltaY/stage.scale.y
      }
      stage.pivot.set(pivot.x, pivot.y);
      this.$refs.renderer.renderUpdate();
    },
    onPanEnd() {
      this.updateAllContainerBounds();
      this.$emit("panend");

      const stage = this.$refs.renderer.pixiApp.stage;
      const {x,y} = stage.pivot
      this.emitCenter();
    },
    updateAllContainerBounds() {
      this.$refs.renderer.renderUpdate();
      this.$refs.renderer.renderTools.addToRunBatch( () => {
        Object.values(this.holderData).forEach( ({updateContainerBounds}) => {
          updateContainerBounds(true);
        });
        this.$refs.renderer.renderTools.addToRunBatch( () => {
        this.$refs.renderer.renderTools.addToRunBatch( () => {
          this.dragging = false;
        });
        });
      });
    },
    addTarget({key,transform,bounds,holder,updateContainerBounds,indirectlySelected}) {

      this.targetsToAdd.push({
        transform,
        key,
        bounds,
        indirectlySelected,
        updateContainerBounds,
        holder
      });
      this.$refs.renderer.renderTools.addToRunBatch( () => {
        const addedTargets = {};
        for (let i = 0; i < this.moveableTargets.length; i++) {
          const target = this.moveableTargets[i];
          addedTargets[target.key] = true;
        }
        const newTargets = [];
        for (let i = 0; i < this.targetsToAdd.length; i++) {
          const toAdd = this.targetsToAdd[i];
          if (!addedTargets[toAdd.key]) {
            newTargets.push(toAdd);
          }
          addedTargets[toAdd.key] = true;
        }
        this.$set(this, 'moveableTargets', this.moveableTargets.concat(newTargets));

        this.targetsToAdd = [];
      }, 'addTarget')
    },
    updateTarget(key, {indirectlySelected}) {
      const targetToUpdate = this.moveableTargets.filter( (t) => {
        return t.key === key;
      })[0];
      targetToUpdate.indirectlySelected = indirectlySelected;
    },
    removeTarget({key}) {
      this.targetsToRemove.add(key);
      this.$refs.renderer.renderTools.addToRunBatch( () => {
        this.$set(this, 'moveableTargets', this.moveableTargets.filter( (mt) => {
          return !this.targetsToRemove.has(mt.key);
        }));
        this.targetsToRemove = new Set();
      }, 'removeTarget');
    },
    onKeyUp(e) {
      this.shiftPressed = e.shiftKey;
    },
    onKeyDown(e) {
      this.shiftPressed = e.shiftKey;
    },
    onSelectAdd({transform, bounds, container, updateContainerBounds, holder}) {
      this.setIndirects(transform);
      this.$set(this.selections, transform.id, true);
      this.multipleSelections.push({
        transform,
        bounds,
        container,
        updateContainerBounds,
        holder
      });
      this.$emit("possible-selections", {
        possibleSelections:this.multipleSelections,
        dontAutoSelect: true
      });

    },
    onSelect({transform, bounds, container, updateContainerBounds, holder}) {
      console.log("SELEEEEEEEEEEEEEEEEEEEEEEEEEEEE");
      this.multipleSelections.push({
        transform,
        bounds,
        container,
        updateContainerBounds,
        holder
      });
      /*
      if (!this.shiftPressed) {
        Object.keys(this.selections).forEach( (id) => {
          this.$set(this.selections, id, false);
        });
        Object.keys(this.indirectSelections).forEach( (id) => {
          this.$set(this.indirectSelections, id, false);
        });
      }
      this.setIndirects(transform);
      this.$set(this.selections, transform.id, true);
      */
    },
    setIndirects(transform) {
      // TODO: this is duplicated between UndoRenderer and EditRenderer :-(
      const allChildren = this.partutil.findAllChildrenFromTransform(transform);
      allChildren.forEach( (child) => {
        if (child.id !== transform.id) {
          this.$set(this.indirectSelections, child.id, true);
          this.$set(this.selections, child.id, true);
        } else {
          this.$set(this.indirectSelections, child.id, false);
          this.$set(this.selections, child.id, true);
        }
      });
    },
    onDeselect({transform}) {
      this.$set(this.selections, transform.id, false);
      this.$set(this.indirectSelections, transform.id, false);
    },
    deselectAll(manual=false) {
      if (this.dragging) {
        return;
      }
      if (manual || !this.selecting) {
        Object.keys(this.selections).forEach( (id) => {
          this.$set(this.selections, id, false);
        });
        Object.keys(this.indirectSelections).forEach( (id) => {
          this.$set(this.indirectSelections, id, false);
        });
      }
      this.$emit('deselect');
    },
    renderChild(transform) {
      return true;
      if (this.loading) {
        return true;
      } else {
        return this.enableCaching(transform, 0);
      }
      //return this.loading || (this.enableCaching && transform.children.length);
    },
    enableCaching(transform, depth) {
      return true;
      return depth === 0;
      return false;
      return !this.loading && transform.children.length && depth === 0;
    return !this.busyDragging;
    return !this.busyDragging || this.hasSelection == transform.id;
    },
    startLoading({container,pixiApp,canvas}) {
    },
    doneLoading({container,pixiApp,canvas}) {
      if (this.isFirstLoad) {
        this.$emit("first-load");
        this.isFirstLoad = false;
      }

      this.emitCenter();
    },
    onDragStartUndo({data}) {
      this.$emit("drag-start", {data});
    },
    onDragEndUndo({data}) {
      this.$emit("drag-end", {data});
    },
    onRotateStartUndo(data) {
      this.$emit('rotate-start', data);
    },
    onRotateEndUndo(data) {
      this.$emit('rotate-end', data);
    },
    onScaleStartUndo(data) {
      this.$emit('scale-start', data);
    },
    onScaleEndUndo(data) {
      this.$emit('scale-end', data);
    },
    onSaveDraft() {
      this.$emit('save-draft');
    },
    onTap({clientX,clientY}) {
      this.$refs.renderer.onTap({
        center:{
          x:clientX,
          y:clientY
        },
      });
      //this.$emit("tap", data);
    },
    async setCanvasSize(width,height) {
      await this.$refs.renderer.setCanvasSize(width, height);
    },
    async resizeCanvas() {
      await this.$refs.renderer.resizeCanvas();
      //this.showTransforms = false;
      //setTimeout( () => {
        //this.showTransforms = true;
      //}, 0);
    },
    getScreenCanvasCenterPoint() {
      const stage = this.$refs.renderer.pixiApp.stage;
      const pivot = stage.pivot;
      const boundingBox = this.$el.getBoundingClientRect();
      const center = {
        x:boundingBox.width/2,
        //y:boundingBox.height/2
        //y:pivot.y * stage.scale.y
        y:boundingBox.height/2
      }

      center.x += pivot.x * stage.scale.x;
      center.y += pivot.y * stage.scale.y;
      return center;
    },
    gotoCenter() {
      const stage = this.$refs.renderer.pixiApp.stage;
      stage.pivot.set(0, 0);
      this.$refs.renderer.renderUpdate();
      this.emitCenter();
      this.updateAllContainerBounds();
    },
    gotoPosition(p) {
      const renderTools = this.$refs.renderer.renderTools;
      const container = this.$refs.renderer.container;
      const stage = this.$refs.renderer.pixiApp.stage;

      //p.x += 4;
      //p.y += 10;

      //p.x = -9;
      //p.y = -16;
      let {x,y} = renderTools.worldToScreen(p);
      stage.pivot.set(x, y);

      this.$refs.renderer.renderUpdate();
      this.emitCenter();
      this.updateAllContainerBounds();
    },
    emitCenter() {
      const stage = this.$refs.renderer.pixiApp.stage;
      const {x,y} = stage.pivot;
      this.$emit("change-center", {
        x,
        y
      });
    },
    onSelectionsStart() {
      Object.keys(this.selections).forEach( (id) => {
        this.$set(this.selections, id, false);
      });
      Object.keys(this.indirectSelections).forEach( (id) => {
        this.$set(this.indirectSelections, id, false);
      });

      this.multipleSelections = [];
    },
    onSelectionsEnd() {
      console.log('selections end!!!');
      if (this.multipleSelections.length === 1) {
        this.selectOne(this.multipleSelections[0].transform);

        this.$emit("possible-selections", {
          possibleSelections:this.multipleSelections
        });

      } else {
        //this.multipleSelections.forEach( (data) => {
          //this.onSelectAdd(data);
        //});

        this.$emit("possible-selections", {
          possibleSelections:this.multipleSelections
        });
      }

      //this.$emit(
    },
    selectOne(transform) {
      console.log('SELECT TRANSFORM', transform);
      Object.keys(this.selections).forEach( (id) => {
        this.$set(this.selections, id, false);
      });
      Object.keys(this.indirectSelections).forEach( (id) => {
        this.$set(this.indirectSelections, id, false);
      });

      this.setIndirects(transform);
      this.$set(this.selections, transform.id, true);
    },
  },
  mounted() {
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);
    this.targetsToAdd = [];
    this.targetsToRemove = new Set();
    this.$refs.renderer.enableInteraction();

    this.$refs.renderer.renderTools.on('autoscale', this.onAutoScale);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('keyup', this.onKeyUp);
    clearTimeout(this._resetAfterMouseWheelTimeout);
    if (this.$refs && this.$refs.renderer) {
      this.$refs.renderer.renderTools.off('autoscale', this.onAutoScale);
    }
  },
  computed:{
    canvasBounds() {
      const {cols,rows} = this.size;
      const pad = 0.1
      return {
        x1:-cols/2 - pad, x2:cols/2 + pad,
        y1:-rows/2 - pad, y2:rows/2 + pad
      }
    },
    style() {
      return {
        'background-color':this.backgroundColor
      }
    },
    nothingSelected() {
      return Object.values(this.selections)
        .filter( (selected) => {
          return selected;
        })
        .length === 0;
    },
    transformContext() {
      if (this.dragging) {
        return {
          noCacheAsBitmap: true
        }
      } else {
        return {
        }
      }
    },
    ...mapState(['draggingKeepRatio', 'isAdvancedMode'])
  },
  watch:{
    busyDragging(nv) {
      if (nv) {
        this.$refs.renderer.disableInteraction();
      } else {
        this.$refs.renderer.enableInteraction();
      }
    },
  }
}
</script>

